import BaseAPI from '@/services/api/internal/tools/baseAPI';
import BaseModule from '@/store/baseModule';
import BaseService from '@/services/services/tools/baseService';
import { formatDateToInputDateTime } from '@/business/utils/dates';
import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import { treatsItems } from '@/business/apiTreatment/response/baseAPITreatment';

const attributesObjRef = {};
const attributesObj = {
  entity_nav_full_id: {
    type: '$instr',
    values: [],
  },
};
const booleanFieldNames = ['scheduled'];
const treatListResponse = treatsItems({
  booleanFieldNames,
});

export default (store) => {
  store.registerModule(
    ['technicians', 'interventions'],
    new BaseModule({
      serviceAPI: new BaseService({
        api: new BaseAPI({
          url: `${process.env.P2H_BASE_URI}/staff/interventions`,
        }),
        treatListResponse,
      }),
      attributesObj,
      attributesObjRef,
      pageSizeIndex: 4,
      dateMin: formatDateToInputDateTime(
        new Date(Date.now()).setHours(0, 0, 0, 0)
      ),
      makeQueryParams: makeListRequest({
        dateField: 'event_datetime',
        dateNullable: false,
        limitItemsRequest: 100,
        useEntities: true,
      }),
    })
  );
};
